import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-12 ${align === 'center' ? 'text-center' : 'text-left'} ${className}`} data-id="element-160">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-161">
        {title.split(' ').map((word, i) => {
        // Highlight specific words if they match certain patterns, or just alternate
        const isHighlight = word.toLowerCase() === 'sistema' || word.toLowerCase() === 'agarre' || word.toLowerCase() === 'dominio';
        return <span key={i} className={isHighlight ? 'text-neon-cyan text-shadow-neon' : 'text-white'} data-id="element-162">
              {word}{' '}
            </span>;
      })}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} className="text-xl md:text-2xl text-gray-400 font-inter max-w-3xl mx-auto" data-id="element-163">
          {subtitle}
        </motion.p>}
    </div>;
}